if (!customElements.get('monblari-video-guides')) {
  customElements.define('monblari-video-guides', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.entries = Array.from(this.querySelectorAll('[data-entry]')).filter(e => /^[A-Za-z0-9_-]{11}$/.test(e.dataset.videoId));
      if (!this.entries.length) return;
      this.tabs = this.querySelector('.mbv-tabs');
      this.select = this.querySelector('[data-mobile-select]');
      this.screen = this.querySelector('.mbv-screen');
      this.play = this.querySelector('.mbv-play');
      this.querySelector('.mbv-view').hidden = false;
      this.querySelector('.mbv-mobile-picker').hidden = false;
      this.tabs.hidden = false;
      this.classList.add('mbv-ready');
      this.tabs.querySelectorAll('[data-topic]').forEach(b => { b.hidden = !this.entries.some(e => e.dataset.topic === b.dataset.topic); });
      this.onClick = event => {
        const tab = event.target.closest('button[data-topic]');
        const link = event.target.closest('[data-select]');
        if (tab && this.contains(tab)) this.chooseTopic(tab.dataset.topic);
        if (link && this.contains(link)) {
          event.preventDefault();
          this.choose(link.closest('[data-entry]'));
        }
        if (event.target.closest('.mbv-play') && this.contains(event.target)) this.loadVideo();
      };
      this.onChange = event => {
        if (event.target === this.select) this.choose(this.entries.find(e => e.dataset.block === this.select.value));
      };
      this.onBlock = event => {
        const entry = event.target.closest('[data-entry]');
        if (entry && this.entries.includes(entry)) {
          this.chooseTopic(entry.dataset.topic);
          this.choose(entry);
        }
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onChange);
      this.addEventListener('shopify:block:select', this.onBlock);
      this.chooseTopic(this.entries[0].dataset.topic);
    }
    chooseTopic(topic) {
      const rows = this.entries.filter(e => e.dataset.topic === topic);
      if (!rows.length) return;
      this.tabs.querySelectorAll('[data-topic]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.topic === topic)));
      this.entries.forEach(e => { e.hidden = e.dataset.topic !== topic; });
      this.select.replaceChildren();
      let previous = null;
      rows.forEach(e => {
        const group = e.querySelector('.mbv-group');
        if (group) group.hidden = e.dataset.group === previous;
        previous = e.dataset.group;
        const option = document.createElement('option');
        option.value = e.dataset.block;
        option.textContent = [e.dataset.group, e.querySelector('[data-select]').textContent.trim()].filter(Boolean).join(' — ');
        this.select.append(option);
      });
      this.choose(rows[0]);
    }
    choose(entry) {
      if (!entry) return;
      this.screen.querySelector('iframe')?.remove();
      this.current = entry;
      this.entries.forEach(e => {
        const a = e.querySelector('[data-select]');
        if (e === entry) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
      this.select.value = entry.dataset.block;
      const fragment = entry.querySelector('template').content.cloneNode(true);
      const cover = fragment.querySelector('.mbv-cover');
      const slot = this.querySelector('.mbv-cover-slot');
      slot.replaceChildren();
      if (cover) slot.append(cover);
      const caption = fragment.querySelector('.mbv-caption');
      const output = this.querySelector('.mbv-caption-slot');
      output.replaceChildren();
      if (caption) output.append(caption);
      this.querySelector('.mbv-youtube').href = 'https://www.youtube.com/watch?v=' + entry.dataset.videoId;
      this.play.hidden = false;
      this.play.setAttribute('aria-label', this.dataset.playLabel + ': ' + output.querySelector('h2').textContent.trim());
    }
    loadVideo() {
      if (!this.current || this.screen.querySelector('iframe')) return;
      const frame = document.createElement('iframe');
      frame.src = 'https://www.youtube-nocookie.com/embed/' + this.current.dataset.videoId + '?autoplay=1&playsinline=1&rel=0';
      frame.title = this.querySelector('.mbv-caption h2').textContent.trim();
      frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      frame.allowFullscreen = true;
      frame.referrerPolicy = 'strict-origin-when-cross-origin';
      this.screen.append(frame);
      this.play.hidden = true;
      frame.focus();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('shopify:block:select', this.onBlock);
      this.screen?.querySelector('iframe')?.remove();
      this.ready = false;
    }
  });
}
